import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { ledgerApi } from "./api";

/** Shared by the page and the sidebar, so the counts and the page never disagree. */
export function useLedgerSessions() {
	return useQuery({ queryKey: ["ledger", "sessions"], queryFn: () => ledgerApi.sessions() });
}

export function useLedgerGaps() {
	return useQuery({ queryKey: ["ledger", "gaps"], queryFn: () => ledgerApi.gaps() });
}

export const TRANSCRIPT_PAGE_SIZE = 100;

/**
 * One session's transcript, a page at a time. Each page is a fixed offset
 * window, so flattening the pages in order never repeats a message.
 */
export function useLedgerTranscript(id: string, { enabled = true }: { enabled?: boolean } = {}) {
	return useInfiniteQuery({
		queryKey: ["ledger", "transcript", id],
		enabled,
		queryFn: ({ pageParam }) =>
			ledgerApi.transcript({
				params: { id },
				query: { page: pageParam, pageSize: TRANSCRIPT_PAGE_SIZE },
			}),
		initialPageParam: 1,
		getNextPageParam: (last, all) => {
			const loaded = all.reduce((sum, page) => sum + page.items.length, 0);
			return loaded < last.total && last.items.length > 0 ? last.page + 1 : undefined;
		},
	});
}
